"use strict";

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard"),
    _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: !0
}), exports["default"] = void 0;

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends")),
    _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck")),
    _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass")),
    _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/inherits")),
    _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime/helpers/possibleConstructorReturn")),
    _getPrototypeOf2 = _interopRequireDefault(require("@babel/runtime/helpers/getPrototypeOf")),
    _react = _interopRequireWildcard(require("react")),
    _classnames = _interopRequireDefault(require("classnames")),
    _Icon = _interopRequireDefault(require("../../Icon")),
    _Input = _interopRequireDefault(require("../../Input")),
    _Image = _interopRequireDefault(require("../../Image")),
    _NavigationLink = _interopRequireDefault(require("./NavigationLink")),
    _Button = _interopRequireDefault(require("../../Button")),
    _navMobileMenu = require("../styles/navMobileMenu"),
    _onEnterPressed = _interopRequireDefault(require("../../../common/utils/onEnterPressed")),
    _Text = _interopRequireDefault(require("../../Text"));

require("../styles/_nav-menu-mobile.scss");

function _createSuper(a) {
  var b = _isNativeReflectConstruct();

  return function () {
    var c,
        d = (0, _getPrototypeOf2["default"])(a);

    if (b) {
      var e = (0, _getPrototypeOf2["default"])(this).constructor;
      c = Reflect.construct(d, arguments, e);
    } else c = d.apply(this, arguments);

    return (0, _possibleConstructorReturn2["default"])(this, c);
  };
}

function _isNativeReflectConstruct() {
  if ("undefined" == typeof Reflect || !Reflect.construct) return !1;
  if (Reflect.construct.sham) return !1;
  if ("function" == typeof Proxy) return !0;

  try {
    return Date.prototype.toString.call(Reflect.construct(Date, [], function () {})), !0;
  } catch (a) {
    return !1;
  }
}

var NavigationMenuMobile = function (a) {
  function b(a) {
    var d;
    return (0, _classCallCheck2["default"])(this, b), d = c.call(this, a), d.toggleMinimiseState = function () {
      d.setState(function (a) {
        var b = a.minimised;
        return {
          minimised: !b,
          searchActive: !1
        };
      });
    }, d.toggleSearchState = function () {
      d.setState(function (a) {
        var b = a.searchActive;
        return {
          searchActive: !b
        };
      });
    }, d.renderNavLink = function (a) {
      var b = a.label,
          c = a.icon,
          e = a.url,
          f = a.selected,
          g = a.onClick,
          h = a.disableMinimiseOnClick,
          i = a.className,
          j = d.props,
          k = j.history,
          l = j.primaryLinksColour,
          m = j.primaryLinksSelectedColour,
          n = function n() {
        return h || d.toggleMinimiseState(), g ? g() : k.push(e);
      };

      return _react["default"].createElement(_NavigationLink["default"], {
        key: e,
        onClick: n,
        label: b,
        selected: f,
        icon: c,
        className: i,
        linkColour: l,
        linkHoverColor: m,
        linkSelectedColor: m,
        rounded: !0
      });
    }, d.renderMinimized = function () {
      var a = d.props,
          b = a.onNotificationsClick,
          c = a.onSearch,
          e = a.primaryLinksColour,
          f = d.state.searchActive;
      return _react["default"].createElement("div", {
        className: (0, _classnames["default"])("nav-menu-mobile__header", _navMobileMenu.MENU)
      }, _react["default"].createElement(_Icon["default"], {
        name: "alignjustified",
        color: e || "darkdenim",
        onClick: d.toggleMinimiseState
      }), c ? _react["default"].createElement(_Input["default"], {
        id: "global-search",
        prefix: d.renderSearchIcon(),
        styleType: "TEXT",
        className: (0, _classnames["default"])(_navMobileMenu.GLOBAL_SEARCH, f ? _navMobileMenu.GLOBAL_SEARCH_ACTIVE : void 0),
        onChange: c,
        placeholder: "Search",
        suffixIcon: f ? _react["default"].createElement(_Icon["default"], {
          name: "close",
          color: "regent",
          size: 10,
          onClick: d.toggleSearchState
        }) : null
      }) : null, _react["default"].createElement(_Icon["default"], {
        name: "notifications",
        onClick: b,
        color: e || "darkdenim",
        size: 20
      }));
    }, d.renderExpanded = function () {
      var a = d.props,
          b = a.topRoutes,
          c = a.bottomRoutes,
          e = a.user,
          f = a.primaryButtonProps,
          g = a.primaryLinksColour,
          h = d.state.minimised;
      return _react["default"].createElement("div", {
        className: (0, _classnames["default"])("nav-menu-mobile__menu", (0, _navMobileMenu.MENU_EXPANDED_CONTAINER)(h))
      }, _react["default"].createElement("div", {
        className: (0, _classnames["default"])("nav-menu-mobile__menu__header", _navMobileMenu.MENU_EXPANDED_HEADER)
      }, _react["default"].createElement(_Icon["default"], {
        className: _navMobileMenu.CLOSE_BTN,
        name: "close",
        size: 16,
        color: g || "darkdenim",
        onClick: d.toggleMinimiseState,
        onKeyDown: (0, _onEnterPressed["default"])({
          onClick: d.toggleMinimiseState
        })
      })), e && _react["default"].createElement("div", {
        className: (0, _navMobileMenu.USER_INFO)({
          primaryLinksColour: g
        })
      }, _react["default"].createElement(_Image["default"], {
        imageUrl: e.imageUrl,
        defaultImageIcon: "user",
        defaultIconColour: "russian",
        height: "40px",
        width: "40px",
        onClick: e.onUserClick,
        circular: !0
      }), _react["default"].createElement("div", {
        className: _navMobileMenu.USER_INFO_TEXT
      }, _react["default"].createElement(_Text["default"], {
        button: !0,
        noMargin: !0
      }, e.fullName), _react["default"].createElement(_Text["default"], {
        caption: !0,
        noMargin: !0
      }, e.role))), f ? _react["default"].createElement(_Button["default"], (0, _extends2["default"])({}, f, {
        type: "TERTIARY",
        prefix: "addfat",
        prefixSize: 15
      })) : null, _react["default"].createElement("div", {
        className: (0, _classnames["default"])("nav-menu-mobile__menu__links", _navMobileMenu.TOP_MENU_LINKS)
      }, b.map(d.renderNavLink)), c && _react["default"].createElement("div", {
        className: (0, _classnames["default"])("nav-menu-mobile__menu__links", _navMobileMenu.BOTTOM_MENU_LINKS)
      }, c.map(d.renderNavLink)));
    }, d.state = {
      minimised: !0,
      searchActive: !1
    }, d;
  }

  (0, _inherits2["default"])(b, a);

  var c = _createSuper(b);

  return (0, _createClass2["default"])(b, [{
    key: "renderSearchIcon",
    value: function renderSearchIcon() {
      var a = this.state.searchActive;
      return _react["default"].createElement(_Icon["default"], {
        name: "search",
        color: "black",
        size: 20,
        onClick: a ? void 0 : this.toggleSearchState
      });
    }
  }, {
    key: "render",
    value: function render() {
      var a = this.props.primaryColour;
      return _react["default"].createElement("div", {
        className: (0, _classnames["default"])("nav-menu-mobile", (0, _navMobileMenu.MENU_CONTAINER)(a))
      }, this.renderMinimized(), this.renderExpanded());
    }
  }]), b;
}(_react.Component);

exports["default"] = NavigationMenuMobile, NavigationMenuMobile.defaultProps = {
  isExpandable: !0
};